import React from "react";

const Section15Prohibitions = () => (
  <>
    <h2>15. Prohibited Activities</h2>
    <div className="terms-table-container">
      <table className="terms-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Activity</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Unauthorized Access</td>
            <td>Attempting to access accounts, systems, or data that you are not authorized to access.</td>
          </tr>
          <tr>
            <td>Data Scraping</td>
            <td>Using bots, scrapers, or other automated means to collect data from the Service without permission.</td>
          </tr>
          <tr>
            <td>IP Infringement</td>
            <td>Violating the intellectual property rights of Comparedly Ltd. or any third party.</td>
          </tr>
          <tr>
            <td>Malicious Software</td>
            <td>Distributing viruses, malware, or other harmful software through the Service.</td>
          </tr>
          <tr>
            <td>Service Disruption</td>
            <td>Engaging in any activity that disrupts or interferes with the operation of the Service or other users' experience.</td>
          </tr>
          <tr>
            <td>Platform Violation</td>
            <td>Violating the terms of service of any social media platforms accessed through the Service.</td>
          </tr>
          <tr>
            <td>Illegal Activities</td>
            <td>Using the Service for any unlawful purpose or in violation of any applicable laws or regulations.</td>
          </tr>
          <tr>
            <td>Reverse Engineering</td>
            <td>Attempting to reverse engineer, decompile, or disassemble any part of the Service.</td>
          </tr>
          <tr>
            <td>Spamming</td>
            <td>Using the Service to send unsolicited or unauthorized messages, advertisements, or spam.</td>
          </tr>
          <tr>
            <td>Misrepresentation</td>
            <td>Impersonating another user or entity, or providing false or misleading information.</td>
          </tr>
          <tr>
            <td>Security Breach</td>
            <td>Attempting to probe, scan, or test the vulnerability of the Service or any associated system or network, or to breach security or authentication measures.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </>
);

export default Section15Prohibitions;
